module.exports = __webpack_public_path__ + "media/images/home-bg-1440-4af64f63efce9d816f60dd7aeae8af29.png";